import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { css } from 'styled-components'

interface Props {
  isLoading?: boolean
  hasText?: boolean
}

export const ButtonLoading: React.FC<Props> = ({ isLoading, hasText }) => {
  if (!isLoading) {
    return null
  }

  return (
    <div css={hasText && textOffset} data-test="loading-wrapper-icon">
      <FontAwesomeIcon icon="spinner" size="sm" spin={true} />
    </div>
  )
}

const textOffset = css`
  top: 6px;
  left: 7px;
  position: absolute;
`
